import { type FC } from 'react';

// import { type ReactNode, useRef } from 'react';
// import AppleLogoIcon from '@assets/img/icons/apple.svg?react';
// import FacebookLogoIcon from '@assets/img/icons/facebook.svg?react';
// import GoogleLogoIcon from '@assets/img/icons/google-logo.svg?react';
// import XLogoIcon from '@assets/img/icons/x-logo.svg?react';
// import { ENV } from '@/common/app/env';
// import { SocialLoginButton } from '../Buttons/SocialLoginButton';
import { TelegramLoginButton } from '../Buttons/TelegramLoginButton';
import { TonWalletLoginButton } from '../Buttons/TonWalletLoginButton';

const LoginButtonsSection: FC = () => {
  // const ref = useRef<HTMLDivElement | null>(null);
  // const socialIcons: {
  //   twitter: () => ReactNode;
  //   apple: () => ReactNode;
  //   facebook: () => ReactNode;
  //   google: () => ReactNode;
  // } = {
  //   twitter: () => <XLogoIcon className="w-6 h-6 shrink-0" />,
  //   apple: () => <AppleLogoIcon className="w-6 h-6 shrink-0" />,
  //   facebook: () => <FacebookLogoIcon className="w-6 h-6 shrink-0" />,
  //   google: () => <GoogleLogoIcon className="w-6 h-6 shrink-0" />,
  // };

  // const listOfSocials = ['apple', 'facebook', 'google', 'twitter'] as const;

  // const socialLogin = (): void => {
  //   window.location.href = `${ENV.API_BACKEND_URL}/auth/auth0/login`;
  // };

  return (
    <div className="w-full flex flex-col gap-2 mb-8">
      <TelegramLoginButton />
      <TonWalletLoginButton />
      {/* <div ref={ref} className="w-full flex gap-2">
        {listOfSocials.map((social) => (
          <SocialLoginButton
            onClick={socialLogin}
            icon={socialIcons[social]}
            className="flex-1"
          />
        ))}
      </div> */}
    </div>
  );
};

export { LoginButtonsSection };
